export const AW_PORTFOLIO_API_URL = process.env?.AWAPI_AWPORTFOLIO_URL || '/awportfolio/api';
export const AW_PORTFOLIO_API_URL_AGRAPH =
  process.env?.AWAPI_AWPORTFOLIO_URL_AGRAPH || '/api/wealth/legacy/aw-portfolio/v1';

export type AW_PORTFOLIO_TAGS = 'ACCOUNT' | 'MODEL' | 'BENCHMARK' | 'ENTITLED_MODEL';

/**
 * Portfolio endpoints that should have userOverride parameter in ActAs mode
 */
export const ACTAS_USER_OVERRIDE_APPLICABLE_ENDPOINTS = [
  'user-paginate/ACCOUNT',
  'user-paginate/PORTFOLIO_TAG_ACCOUNT',
  'aggregates/user-paginate',
];
